import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Paper, Tooltip, FormControlLabel } from '@mui/material';
import FilterDropDown from 'shared/components/FilterDropDown';
import CheckboxMui from 'shared/components/Checkbox';

//function FilterDropDown() { return null }

export default function TableHeader({
  columns,
  scrollTop,
  checked,
  indeterminate,
  handleSelectAll,
  hasCheckBox,
  onHeaderClick,
  rows,
  onFilterValue,
  sortByColumn,
  sortDirection,
}) {
  //const tableTop = showMoreFilters ? '207px' : '57px'
  const handleClick = useMemo(
    () =>
      (columns ?? []).map(column => event => {
        if (onHeaderClick) {
          onHeaderClick(column, event);
        }
      }),
    [columns],
  );

  if (!columns) {
    return null;
  }

  return (
    <TableHeaderContainer id="h-table-root" {...{ scrollTop }}>
      {hasCheckBox && (
        <Tooltip title={checked ? 'Deselect All' : 'Select all'}>
          <HeaderCell
            id="h-table-headercell"
            style={{ marginLeft: 4, minWidth: 50 }}
          >
            <Checkbox
              size="small"
              {...{ checked, indeterminate }}
              onChange={handleSelectAll}
            />
          </HeaderCell>
        </Tooltip>
      )}
      {columns
        ?.filter(column => column)
        ?.map(({ headerName, field, width, filter, flex }, index) =>
          filter ? (
            <FilterDropDown
              key={`${headerName}-${field}`}
              name={field}
              buttonTitle={headerName}
              onValue={onFilterValue}
              sorted
              flex={flex}
              width={width}
              {...{ field, rows }}
              buttonTextColor="#fff"
              noButtonBorder
            />
          ) : (
            <HeaderCell
              id="h-table-headercell-b"
              key={`${headerName}-${field}`}
              style={{
                minWidth: width, //width - (index || !hasCheckBox ? 0 : 16),
              }}
              onClick={handleClick[index]}
            >
              {headerName}
              <FloatingRight>
                {sortByColumn == headerName
                  ? sortDirection !== undefined
                    ? sortDirection
                      ? ' ▼'
                      : ' ▲'
                    : ''
                  : ''}
              </FloatingRight>
            </HeaderCell>
          ),
        )}
    </TableHeaderContainer>
  );
}

export function CardViewHeader({
  scrollTop,
  handleSelectAll,
  indeterminate,
  checked,
}) {
  return (
    <CardViewContainer {...{ scrollTop }}>
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            {...{ checked, indeterminate }}
            onChange={handleSelectAll}
          />
        }
        label={checked === true ? 'Deselect All' : 'Select all'}
      />
    </CardViewContainer>
  );
}

const HeaderCell = styled.div`
  position: relative;
  padding: 0 4px;
  display: flex;
  align-items: center;
  user-select: none;
  background-color: transparent;
  font-weight: 600;
  font-size: 16px;
  color: #595959;
  border-left: 1px solid #ccd7e3;
  height: 30px;
  padding-left: 8px;
  &:nth-child(1) {
    border-left: none;
  }
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
/*
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
*/
const TableHeaderContainer = styled(Paper)`
  display: flex;
  flex-direction: row;
  height: 40px;
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  z-index: 100;
  color: #595959 !important;
  padding-top: 4px;
  font-weight: bold;
  background-color: #f9f9f9 !important;
  backdrop-filter: blur(5px);
  border-width: 0px !important;

  .MuiCheckbox-root {
    color: #cbd6e2 !important;
  }
  .MuiCheckbox-root.Mui-checked {
    color: #f89915 !important;
  }
`;

const CardViewContainer = styled(Paper).attrs({
  elevation: 2,
})`
  display: flex;
  flex-direction: row;
  height: 24px;
  position: absolute;
  left: 0;
  top: ${({ scrollTop }) => scrollTop}px;
  right: 0;
  z-index: 100;
  padding: 0 8px 0 30px;
  color: #fff !important;
  background-color: rgba(32, 32, 32, 0.4) !important;
  backdrop-filter: blur(5px);
`;

const Checkbox = styled(CheckboxMui)`
  span.MuiIconButton-label {
    width: auto;
    height: auto;
    background-color: transparent;
    border-radius: 2px;
  }
`;

const FloatingRight = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;s
`;
